/** Hero portrait display and upload crop aspect (width / height). */
export const HERO_PORTRAIT_ASPECT = 16 / 10

export const HERO_PORTRAIT_MAX_WIDTH = 1600

export const HERO_PORTRAIT_WIDTH = 1600

export const HERO_PORTRAIT_HEIGHT = 1000
